import { render } from "./HRDocuments.vue?vue&type=template&id=3830ab8a&scoped=true"
import script from "./HRDocuments.vue?vue&type=script&lang=js"
export * from "./HRDocuments.vue?vue&type=script&lang=js"

import "./HRDocuments.vue?vue&type=style&index=0&id=3830ab8a&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3830ab8a"]])

export default __exports__